<div class="flex items-center justify-between gap-4 rounded-[10px] border border-[var(--mat-app-outline-variant)] bg-[var(--mat-app-secondary-container)] px-4 py-2.5">
  <span class="text-sm">
    {{ "COMMON.PASSWORD_EXPIRY_BANNER.MESSAGE" | translate: { days: daysRemaining } }}
  </span>

  <div class="flex items-center gap-2 shrink-0">
    <a [routerLink]="profilePath" class="text-sm font-medium underline">
      {{ "COMMON.PASSWORD_EXPIRY_BANNER.ACTION" | translate }}
    </a>

    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'BTN.DISMISS' | translate"
      (click)="onDismiss()">
      <mat-icon svgIcon="cross"></mat-icon>
    </button>
  </div>
</div>
